import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
import { css } from '@emotion/react';
import { BrandButton, Button, Colors, Grid, Heading, HeadingLevel, Icon, Link, TagLabel, Typography, } from '../../../index';
const Styles = labelStyles('TwoColumnRiver', {
    root: (backgroundColor = 'neutral100') => css `
    background-color: ${Colors[backgroundColor]};
    padding: 20px;

    @media screen and (min-width: 640px) {
      padding: 40px 30px;
    }

    @media screen and (min-width: 1024px) {
      padding: 60px 20px;
    }
  `,
    container: (isReversed) => css `
    max-width: 1170px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column-reverse;

    @media screen and (min-width: 1024px) {
      flex-direction: ${isReversed ? 'row-reverse' : 'row'};
    }
  `,
    content: css `
    width: 100%;

    @media screen and (min-width: 1024px) {
      max-width: 500px;
      padding-right: 30px;
    }
  `,
    labelContainer: css `
    margin-bottom: 20px;
  `,
    media: (isReversed) => css `
    margin-bottom: 20px;
    width: 100%;

    @media screen and (min-width: 1024px) {
      max-width: 500px;
      margin: ${isReversed ? '0 40px 0 0' : '0 0 0 40px'};
    }
  `,
    heading: css `
    ${Typography.pageHeader9}
    color: ${Colors.neutral800};
    margin-bottom: 20px;
    @media screen and (min-width: 640px) {
      ${Typography.pageHeader7}
    }

    @media screen and (min-width: 1024px) {
      ${Typography.pageHeader5}
    }
  `,
    description: css `
    ${Typography.paragraph1Short}
    color: ${Colors.neutral800};
    margin-bottom: 20px;
  `,
    cta: css `
    & > a,
    & > button {
      width: 100%;
    }

    @media screen and (min-width: 640px) {
      & > a,
      & > button {
        width: auto;
      }
    }
  `,
    secondaryCta: css `
    margin-top: 20px;
  `,
});
export const TwoColumnRiver = ({ backgroundColor = 'neutral100', ctaColor = 'primary', ctaHref, ctaText, ctaTarget, description, heading, isReversed = false, media, onCtaClick, onCtaKeyDown, onSecondaryCtaClick, onSecondaryCtaKeyDown, secondaryCtaHref, secondaryCtaText, label, labelIcon, labelColor, className, }) => {
    const getCtaComponent = () => {
        const sharedProps = {
            children: ctaText,
            href: ctaHref,
            onClick: onCtaClick,
            onKeyDown: onCtaKeyDown,
            target: ctaTarget,
        };
        return ctaColor === 'brand' ? (isolateComponent(BrandButton, Object.assign({}, sharedProps))) : (isolateComponent(Button, Object.assign({}, sharedProps, { color: ctaColor })));
    };
    return (isolateComponent("div", { css: Styles.root(backgroundColor), className: className },
        isolateComponent("div", { css: Styles.container(isReversed), className: "twoColumnRiver-container" },
            isolateComponent("div", { css: Styles.content, className: "twoColumnRiver-content" },
                label && (isolateComponent("div", { css: Styles.labelContainer, className: "twoColumnRiver-labelContainer" },
                    isolateComponent(TagLabel, { color: labelColor }, labelIcon ? (isolateComponent(Grid, { alignItems: "center", columns: "auto max-content", gap: 5 },
                        isolateComponent(Icon, { name: labelIcon, size: 20 }),
                        label)) : (label)))),
                isolateComponent(HeadingLevel, null,
                    isolateComponent(Heading, { css: Styles.heading }, heading)),
                description && (isolateComponent("div", { css: Styles.description, className: "twoColumnRiver-description" }, description)),
                ctaText && (ctaHref || onCtaClick) && (isolateComponent("div", { css: Styles.cta, className: "twoColumnRiver-cta" }, getCtaComponent())),
                secondaryCtaText && secondaryCtaHref && (isolateComponent("div", { css: Styles.secondaryCta, className: "twoColumnRiver-secondaryCta" },
                    isolateComponent(Link, { href: secondaryCtaHref, onClick: onSecondaryCtaClick, onKeyDown: onSecondaryCtaKeyDown, weight: "bold" }, secondaryCtaText)))),
            media && (isolateComponent("div", { css: Styles.media(isReversed), className: "twoColumnRiver-media" }, media)))));
};
//# sourceMappingURL=TwoColumnRiver.js.map
// @zapier/design-system@6.27.0 (617a97f69)
